import styled from 'styled-components'
import { mediaQuery } from '../../components/utils'

export const NavBarHeight = '60px'

export const Content = styled.div`
    float: left;
    width: calc(100% - ${NavBarHeight});
    overflow-y: auto;
    overflow-x: hidden;

    ${({ fullscreen }) => `height: ${fullscreen ? '100%' : `calc(100% - ${NavBarHeight})`};`}

    ${mediaQuery.mobile(`
        overflow-y: auto;
        width: 100%;
    `)}
`
